import { render, staticRenderFns } from "./usernames_form.vue?vue&type=template&id=4afa68b3&"
import script from "./usernames_form.vue?vue&type=script&lang=js&"
export * from "./usernames_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports